import { SelectOption } from 'govwell-ui/components/Select/types'
import { AicaEmailDigestFrequency } from 'types/graphql'

export const DIGEST_FREQUENCY_OPTIONS: SelectOption<AicaEmailDigestFrequency>[] = [
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Monthly', value: 'Monthly' },
]
